// extracted by mini-css-extract-plugin
module.exports = {"offerCallNumber":"#f3ba28"};